export default class FilenameParser {
  filenameFromUrl(url: string) {
    const decodedUrl = decodeURIComponent(url?.split("?")[0]);
    const filename = decodedUrl.substr(decodedUrl.lastIndexOf("/") + 1);
    if (filename.includes("_project-folder-zip")) {
      return `${filename.split("_project-folder-zip")[0]}.zip`;
    } else {
      return filename;
    }
  }

  folderNameFromUrl(url: string) {
    const decodedUrl = decodeURIComponent(url?.split("?")[0]);
    //not in firebase or google storage
    if( !url.includes("storage.googleapis.com") && !url.includes("firebasestorage") ){
      return null;
      // in google cloud storage
    } else if (!url.includes("firebasestorage")) {
      let tempFolderName = decodedUrl.split("/")
      const finalName = tempFolderName[tempFolderName.length-1].split("_project-folder-zip")[0]
      return finalName;
      // in firebase cloud storage
    } else {
      const withoutFilename = decodedUrl.substr(0, decodedUrl.length - ("/" + this.filenameFromUrl(url)).length);
      const urlParts = withoutFilename.split("/");
      urlParts.reverse();
      const organizationUploadsIndex = urlParts.indexOf("organization_uploads")
      const projectUploadsIndex = urlParts.indexOf("project_uploads")
      let folderIndex;
      if(organizationUploadsIndex !== -1){
        folderIndex = organizationUploadsIndex - 3; // e.g. organization_uploads/some_org_id/some_project_id/some_folder_name
      }
      else if(projectUploadsIndex !== -1){
        folderIndex = projectUploadsIndex - 2; // e.g. project_uploads/some_project_id/some_folder_name
      }
      else{
        return null; // e.g. Anything else we aren't sure
      }
      if(folderIndex < 0){ // There is nothing in the expected folder position
          return null;
      }
      return urlParts[folderIndex];
    }
  }

  rootObjectNameFromUrl(url: string) {
    const folderName = this.folderNameFromUrl(url);
    if (folderName == null) {
      return this.filenameFromUrl(url);
    } else {
      return folderName;
    }
  }
}
